import { FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";

export enum OrganizationInvitationsActionTypes {
    // Organization Invitations
    SET_ORGANIZATION_INVITATIONS_LOADING = "SET_ORGANIZATION_INVITATIONS_LOADING",
    SET_ORGANIZATION_INVITATIONS = "SET_ORGANIZATION_INVITATIONS"
}

// Organization Invitations
type SetOrganizationInvitationsLoadingAction = {
    type: OrganizationInvitationsActionTypes.SET_ORGANIZATION_INVITATIONS_LOADING,
    payload: { isLoading: boolean; }
};

export const setOrganizationInvitationsLoading = (isLoading: boolean): SetOrganizationInvitationsLoadingAction => ({
    type: OrganizationInvitationsActionTypes.SET_ORGANIZATION_INVITATIONS_LOADING,
    payload: { isLoading }
});

type SetOrganizationInvitationsAction = {
    type: OrganizationInvitationsActionTypes.SET_ORGANIZATION_INVITATIONS,
    payload: { axnAdminUserInvitations: Array<FormattedAxnAdminUserInvitation>; }
}

export const setOrganizationInvitations = (axnAdminUserInvitations: Array<FormattedAxnAdminUserInvitation>): SetOrganizationInvitationsAction => ({
    type: OrganizationInvitationsActionTypes.SET_ORGANIZATION_INVITATIONS,
    payload: { axnAdminUserInvitations }
});

export type OrganizationInvitationsActions =
    // Organization Invitations
    SetOrganizationInvitationsLoadingAction |
    SetOrganizationInvitationsAction